module.exports = __webpack_public_path__ + "assets/img/29_235.2508c7f3.jpg";